export interface PodeDesativarInput {
  alvoUserId: string;
  callerUserId: string;
  /** O alvo é o owner da org (organizations.owner_id). Não há role 'owner'. */
  isAlvoOwner: boolean;
}

export type PodeDesativarResult =
  | { permitido: true }
  | { permitido: false; motivo: 'self' | 'owner' };

/** Espelha os guardrails da RPC desativar_membro para esconder a ação na UI. */
export function podeDesativarMembro(input: PodeDesativarInput): PodeDesativarResult {
  if (input.alvoUserId === input.callerUserId) return { permitido: false, motivo: 'self' };
  if (input.isAlvoOwner) return { permitido: false, motivo: 'owner' };
  return { permitido: true };
}

export type DesativarError =
  | { code: 'bloqueado_os_ativas'; count: number }
  | { code: 'limite_plano_atingido' }
  | { code: 'nao_pode_desativar_owner' }
  | { code: 'nao_pode_desativar_a_si_mesmo' }
  | { code: 'membro_nao_encontrado' }
  | { code: 'forbidden' }
  | { code: 'unknown' };

const KNOWN = [
  'limite_plano_atingido',
  'nao_pode_desativar_owner',
  'nao_pode_desativar_a_si_mesmo',
  'membro_nao_encontrado',
  'forbidden',
] as const;

/** Traduz a mensagem crua da RPC num código estável + payload. */
export function parseDesativarError(error: unknown): DesativarError {
  const msg = error instanceof Error ? error.message : String(error ?? '');
  const osMatch = msg.match(/bloqueado_os_ativas:(\d+)/);
  if (osMatch) return { code: 'bloqueado_os_ativas', count: Number(osMatch[1]) };
  const hit = KNOWN.find((c) => msg.includes(c));
  if (hit) return { code: hit } as DesativarError;
  return { code: 'unknown' };
}
